import API from 'shared/constants/api';
import { execPostRequest, getCapacity } from './utils';

export const addUlfLead = async (params, fetch) => {
  const {
    advert,
    userName,
    price,
    term,
    phone,
    prepaid,
    comment,
    temperature,
    popularity,
    liquidityDays,
    commentWithAddData,
    userStorageId,
    type,
  } = params;

  const data = {
    type,
    vehicle: {
      // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
      // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
      manufacturedYear: advert.year, // Необязательный год выпуска
      engineVolume: getCapacity(advert), // Необязательный объем двигателя в см₃
      // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
      // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
      // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
    },
    contact: {
      name: userName,
      // surname: 'Иванов',
      // inn: '1234567890',
      phoneNumber: phone,
    },
    productFrontId: 249, // Вид лизинга
    period: term, // Срок лизинга
    amount: price, // Стоимость авто, грн
    prepayment: prepaid, // Предоплата, грн
    comment,
    utm_source: 'partner',
    utm_medium: 'avtobazar',
    // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
    // utm_term: 'utm_term ', // Необязательный utm-метка
    // utm_content: 'utm_content' // Необязательный utm-метка

    UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
    UF_CRM_1639391200032: popularity || 0, // Популярность
    UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
    UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
    UF_CRM_1639391264973: commentWithAddData, // Комментарий
    UF_CRM_1639391283416: userStorageId, // device id
    // UF_CRM_1639391301711: '', // Результат скоринга
  };
  console.log('Create ULF Lead');
  return execPostRequest(API.ADVERT.LEASING_ULF.ADD_LEAD, data, fetch, {}, 'addlead');
};

export const createUlfLead = async (params, fetch) => {
  let result = null;
  try {
    const comment = `https://avtobazar.ua${params.advert.permalink}`;
    const ulfParams = {
      ...params,
      comment,
      commentWithAddData: '',
      temperature: '',
      type: 'ulf',
    };
    result = await addUlfLead(ulfParams, fetch);
    if (!result || !result.id) throw Error('createUlf24Lead error');
  } catch (e) {
    console.log(e);
  }
  return result;
};

export const getUlfParams = ({ phone, userName, leasingParams, advert }) => ({
  phone,
  userName,
  advert,
  leasingParams,
  term: leasingParams.term,
  prepaid:
    (leasingParams && leasingParams.prepayment) ||
    (leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH),
  price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  userStorageId: localStorage.getItem('applensDeviceId') || '',
});



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/ulf.js